import _ from "lodash";

export const extractContentFromHTML = ({ htmlString, space = true }) => {
  if (!_.isEmpty(htmlString)) {
    const span = document.createElement("span");
    span.innerHTML = htmlString;

    if (space) {
      const children = span.querySelectorAll("*");
      const lengthOfChildren = _.get(children, "length", 0);

      for (let i = 0; i < lengthOfChildren; i++) {
        if (children[i].textContent) {
          children[i].textContent += " ";
        } else if (children[i].tagName === "IMG") {
          // TODO: Fix in case of only image is the child
        } else {
          children[i].innerText += " ";
        }
      }
    }

    return [span.textContent || span.innerText].toString().replace(/ +/g, " ");
  } else {
    return "";
  }
};
